// tr strings for messages/paywall.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const paywall: Dict = {
  "paywall.hl.unlimitedCovers": "Sınırsız cover",
  "paywall.hl.voices": "93.000+ ses",
  "paywall.hl.downloads": "İndirmeler",
  "paywall.hl.duetsTts": "Düetler ve metinden sese",
  "paywall.hl.trainVoices": "Kendi seslerini eğit",
  "paywall.hl.hdVideos": "1080p videolar",
  "paywall.hl.videoCoins": "Ayda 50 video jetonu",
  "paywall.hl.marbleLyric": "Marble Run ve sözlü videolar",
  "paywall.hl.priority": "Öncelikli işleme",
  "paywall.hl.unlimitedCoins": "Sınırsız video jetonu",
  "paywall.hl.apiCredits": "Ayda $25 API kredisi",
  "paywall.hl.everythingCreator": "Creator'daki her şey",
  "paywall.hl.thisCover": "Bu cover, hemen şimdi",

  "paywall.reason.unlock.title": "Cover'ının kilidini aç",
  "paywall.reason.unlock.body":
    "Sesin ve kaydın hazır. Abone ol, cover'ın hemen başlasın ve yaklaşık bir dakikada hazır olsun. Sonra istediğin kadar yap.",
  "paywall.reason.create.title": "Cover'ın yapılmaya hazır",
  "paywall.reason.create.body":
    "Kaydın ve sesin ayarlandı. Yapmak için bir plan seç, sonra istediğin kadar cover yap.",
  "paywall.reason.browse.title": "İstediğin sesle cover yap",
  "paywall.reason.browse.body":
    "Sınırsız cover, indirme ve 93.000+ sesin tamamı. İstediğin zaman iptal et.",
  "paywall.reason.credits.title": "Kredilerini kullandın",
  "paywall.reason.credits.body":
    "Sıradaki cover'ın seni bekliyor. Basic'te limit yok, bir daha kredi saymazsın.",
  "paywall.reason.words.title": "Sese kendi sözlerini söylet",
  "paywall.reason.words.body":
    "Bir metin yaz veya bir şarkıyı tarif et, ses onu söylesin ya da şarkı olarak seslendirsin. Basic'ten itibaren dahil.",
  "paywall.reason.video.title": "Videoya dönüştür",
  "paywall.reason.video.body":
    "TikTok ve Reels'e hazır Marble Run ve sözlü videolar. Creator her ay 50 video jetonu içerir.",
  "paywall.reason.resume.title": "Kaldığın yerden devam et",
  "paywall.reason.resume.body":
    "Planın kaydedildi. Ödemeyi tamamla, sonra istediğin kadar cover yap.",
  "paywall.reason.train.title": "Kimsede olmayan bir ses yarat",
  "paywall.reason.train.body":
    "Birkaç örnekten kendi seslerini eğit ve istediğin cover'da kullan. Creator'da sınırsız.",

  "paywall.cta.unlockFor": "Cover'ımın kilidini aç: {price}",
  "paywall.cta.keepGoingFor": "Devam et: {price}",
  "paywall.cta.backToCreatorFor": "Creator'a geri dön: {price}",
  "paywall.cta.backFor": "Geri dön: {price}",
  "paywall.cta.startFor": "{price} ile başla",
  "paywall.cta.startPlanFor": "{plan} planını başlat: {price}",

  "paywall.renew.welcome":
    "Abone kaldığın sürece ayda {price}. İptal edene kadar her ay yenilenir.",
  "paywall.renew.then":
    "Sonra ayda {price}. İptal edene kadar her ay yenilenir.",
  "paywall.renew.yearly":
    "12 ay için bugün {price} tahsil edilir. İptal edene kadar her yıl yenilenir.",

  "paywall.toast.updated": "Aboneliğin güncellendi!",
  "paywall.toast.error": "Bir şeyler ters gitti, lütfen tekrar dene.",

  "paywall.welcomeBack": "TEKRAR HOŞ GELDİN",
  "paywall.priceMonth": "ayda {price}",
  "paywall.welcome.offerCreator": "ayda {price} karşılığında Creator",
  "paywall.welcome.card":
    "Planın sen ayrıldığın için değil, bir ödeme gerçekleşmediği için durdu. Kaldığın yerden devam et: {offer}.",
  "paywall.welcome.price":
    "Çok pahalı olduğunu söylemiştin, o yüzden daha az: {was} yerine {offer}, abone kaldığın sürece.",
  "paywall.welcome.broken":
    "Bir şeylerin çalışmadığını söylemiştin. Geçen hafta her 100 cover'dan {n} tanesi sorunsuz çıktı. Geri dön: {offer}.",
  "paywall.welcome.secretCreator":
    "Reklamını yapmadığımız bir planla ayda {price} karşılığında Creator. Abone kaldığın sürece senin.",
  "paywall.welcome.secret":
    "Sahip olduğun her şey, reklamını yapmadığımız bir planla ayda {price}. Abone kaldığın sürece senin.",
  "paywall.welcome.coversHere": "{n} cover'ın hâlâ burada",
  "paywall.welcome.coverHere": "Cover'ın hâlâ burada",
  "paywall.welcome.makeAgain": "Yeniden cover yap",
  "paywall.ended.today": "Planın bugün sona erdi",
  "paywall.ended.yesterday": "Planın dün sona erdi",
  "paywall.ended.days": "Planın {n} gün önce sona erdi",
  "paywall.ended.months": "Planın {n} ay önce sona erdi",
  "paywall.more": "daha",

  "paywall.recommended": "ÖNERİLEN",
  "paywall.perMonth": "aylık",
  "paywall.perMonthStay": "aylık, abone kaldığın sürece",
  "paywall.firstMonth": "ilk ay",
  "paywall.today": "bugün",
  "paywall.heldFor": "{time} boyunca saklanıyor",
  "paywall.coverReady": "COVER'IN YAPILMAYA HAZIR",
  "paywall.coverSetUp": "Kaydın ve sesin ayarlandı",
  "paywall.coversToday": "Bugün Jammable'da {n} cover yapıldı",
  "paywall.coversTodayShort": "Bugün {n} cover yapıldı",
  "paywall.pickPlanUnlock": "Kilidini açmak için bir plan seç",
  "paywall.pickPlan": "Bir plan seç",
  "paywall.whatYouGet": "{plan} PLANIYLA NELER ALIRSIN",
  "paywall.secure": "Stripe ile güvenli ödeme · istediğin zaman iptal et",
  "paywall.topPlan": "En üst plandasın",
  "paywall.managePlan": "Planını yönet",

  "paywall.changePlan": "Planı değiştir",
  "paywall.planYearly": "{plan}, yıllık",
  "paywall.planMonthly": "{plan} planı",
  "paywall.billedYearly": "Yıllık faturalandırılır",
  "paywall.pay": "Öde",
  "paywall.payUnlock": "Öde ve kilidi aç",
  "paywall.checkoutLoading": "Ödeme sayfan hazırlanıyor",

  "paywall.leave.title": "Cover'ın olmadan mı çıkıyorsun?",
  "paywall.leave.oneStep": "Sadece bir adım kaldı.",
  "paywall.leave.audioIn": "Kaydın yüklendi",
  "paywall.leave.voiceReady": "{names} söylemeye hazır",
  "paywall.leave.voicesReady": "{names} söylemeye hazır",
  "paywall.leave.voicePicked": "Sesin seçildi",
  "paywall.leave.makeStep": "Cover'ı yap: yaklaşık bir dakika",
  "paywall.leave.gets": "KİLİDİ AÇINCA ŞUNLARI ALIRSIN",
  "paywall.leave.held":
    "{time} boyunca saklanıyor. Sonra silinir ve yeniden yapman gerekir.",
  "paywall.unlockMyCover": "Cover'ımın kilidini aç",
  "paywall.leaveAnyway": "Yine de çık",

  "paywall.gift.wrapping": "Senin için bir şey paketliyoruz…",
  "paywall.gift.beforeYouGo": "GİTMEDEN ÖNCE",
  "paywall.gift.saved": "Sana bir hediye ayırdık",
  "paywall.gift.openToSee": "Ne olduğunu görmek için aç.",
  "paywall.gift.opening": "Açılıyor…",
  "paywall.gift.open": "Hediyemi aç",
  "paywall.gift.noThanks": "Hayır teşekkürler, çık",
  "paywall.gift.yours": "HEDİYEN",
  "paywall.gift.headline": "{plan}, ayda {price}",
  "paywall.gift.body":
    "Tüm seslerle sınırsız cover, 12 ay boyunca sabit fiyat.",
  "paywall.gift.save": "%{pct} TASARRUF",
  "paywall.perMo": "/ay",
  "paywall.gift.billedYearly": "Yıllık {price} faturalandırılır",
  "paywall.gift.lockIn": "Ayda {price} fiyatını sabitle",
  "paywall.seeMonthly": "Aylık planları gör",

  "paywall.locked.step.upload": "Kaydın yükleniyor",
  "paywall.locked.step.match": "Ses eşleştiriliyor",
  "paywall.locked.step.mix": "Miks hazırlanıyor",
  "paywall.locked.yourAudio": "kaydın",
  "paywall.locked.yourAiSong": "yapay zeka şarkın",
  "paywall.locked.yourWords": "sözlerin",
  "paywall.locked.yourVoice": "Sesin",
  "paywall.locked.startFailed": "Cover başlatılamadı. Tekrar dene.",
  "paywall.locked.makeNow": "Şimdi yap",
  "paywall.unlock": "Kilidi aç",
  "paywall.locked.pctDone": "%{pct} tamamlandı",
  "paywall.locked.gettingReady": "{names} hazırlanıyor · {song}",
  "paywall.locked.done": "tamam",
  "paywall.locked.now": "şimdi",
  "paywall.locked.expired": "Bu cover'ın süresi doldu",
  "paywall.locked.expiredBody":
    "Kilitli cover'lar 48 saat saklanır. Bir dakikada yeniden yap.",
  "paywall.locked.makeAgain": "Yeniden yap",
  "paywall.locked.readyToMake": "Yapılmaya hazır",
  "paywall.locked.readyOne":
    "{names} yapay zeka sesi seslendirmeye hazır · {song}",
  "paywall.locked.readyMany":
    "{names} yapay zeka sesleri seslendirmeye hazır · {song}",
  "paywall.locked.onPlan":
    "Bir planın var, bu yüzden hemen başlayabilir. Yaklaşık bir dakika sürer.",
  "paywall.locked.unlockBody":
    "Kilidini aç, cover'ın hemen başlasın. Yaklaşık bir dakika sürer, sonra indirip paylaşabilirsin.",
  "paywall.locked.change": "Sesi veya kaydı değiştir",
  "paywall.locked.notMade": "Bu cover henüz yapılmadı",
  "paywall.locked.makeYourOwn":
    "Yaklaşık bir dakikada kendi cover'ını yap. Ses: {names}.",
  "paywall.locked.makeCover": "Cover yap",

  "paywall.video.unlock": "Cover'ının ve videonun\nkilidini aç",
  "paywall.video.howItLooks": "Videon böyle görünecek",
  "paywall.video.drawing": "Videon çiziliyor",
  "paywall.video.aria": "{cta}: cover'ın ve videosu",

  "paywall.return.firstMonth": "İlk ayın {price}",
  "paywall.return.waiting": "Cover'ın seni bekliyor: {title}",
  "paywall.return.savedWaiting": "Kaydedilen cover'ın seni bekliyor",
  "paywall.return.trialReady": "7 günlük ücretsiz denemen hazır",
  "paywall.return.trialDetail":
    "Bugün ödeme yok, sonra ayda {price}. İstediğin zaman iptal et.",
  "paywall.return.startTrial": "Ücretsiz denememi başlat",
  "paywall.return.funds": "Bankan kartta yeterli bakiye olmadığını söyledi.",
  "paywall.return.declined": "Bankan ödemeyi reddetti.",
  "paywall.return.cardFailed": "Kartından ödeme alınamadı",
  "paywall.return.cardDetail":
    "Kartından ödeme alınamadı. Apple Pay, Google Pay veya başka bir kart dene · {price}",
  "paywall.return.whyDetail":
    "{why} Apple Pay, Google Pay veya başka bir kart dene · {price}",
  "paywall.return.tryAnother": "Başka bir yol dene",
  "paywall.return.confirm": "Bankan kısa bir onay istedi",
  "paywall.return.confirmDetail": "Bir adım daha ve hazırsın · {price}",
  "paywall.return.finish": "Ödemeyi tamamla",
  "paywall.return.planHere": "{plan} planın hâlâ burada",
  "paywall.return.heldMore": "{time} daha saklanıyor · {price}",
  "paywall.return.thenRegular": "{price}, sonra {regular}",
  "paywall.return.cancelAny": "{price}, istediğin zaman iptal et",
  "paywall.return.pickUp": "Kaldığım yerden devam et",
  "paywall.return.cardStopped": "Bir ödeme gerçekleşmediği için planın durdu",
  "paywall.return.comeBack": "Jammable'a geri dön",
  "paywall.return.pickUpFor": "Kaldığın yerden devam et: {offer}.",
  "paywall.return.secretOffer":
    "Reklamını yapmadığımız bir planla geri dön: {offer}.",
  "paywall.return.hide": "Gizle",
};

export default paywall;
